import React from 'react';
import { Box, Button, Container, Typography } from '@material-ui/core';

const KontaktText = (props) => {
  const getMailtopath = (latestEmail) => String('mailto:') + String(latestEmail);

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        pt: 6
      }}
      {...props}
    >
      <Container
        maxWidth="md"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          px: {
            md: '130px !important'
          }
        }}
      >
        <Typography
          align="center"
          color="textPrimary"
          variant="h2"
          component="span"
        >
          Kontakt
        </Typography>
        <Typography
          align="center"
          color="textSecondary"
          variant="body1"
          sx={{ py: 3 }}
        >
          <h2>eyerena – die neue digitale Plattform für ViCo Training</h2>
          <br />
          <h4>erreichbar unter</h4>
          Internet: eyerena.com
          <br />
          <Button
            variant="text"
            href={getMailtopath('hello@eyerena-training.de')}
          >
            hello@eyerena-training.de
          </Button>
          <br />
          <br />
          Adresse:
          <br />
          Albin-Hänseroth-Weg 69
          <br />
          50859 Köln
          <br />
          Deutschland
          <br />
        </Typography>
      </Container>
    </Box>
  );
};

export default KontaktText;
